import React, { useEffect, useState } from 'react';
import { makeStyles, } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Grid, Typography, Divider,} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: 'red'
    }
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },

}));
export default function FormularioSolicitud(props) {
  const { register, errors, setValue, watch, control, defaultItem, getValues, isEdicionOrden, ctlg } = props; //bucarEquipo
  const classes = useStyles();
  
  const cambioProyecto = (e, value) => {
    setValue('proyecto',value);
    setValue("equipo", null);
    // if(value){
    //   bucarEquipo(value);
    // }
  }

  useEffect(() => {
    if (defaultItem.propuesta) {
      console.log('valores');
    } else {
      setValue('proyecto',null);
    }
  }, []);
  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item md={4} xs={6}>
        <Typography variant="body2">Tipo de solicitud : {defaultItem.tipo_solicitud || 'N/D'}</Typography>
      </Grid>
      <Grid item md={4} xs={6}>
        <Typography variant="body2">Prioridad : {defaultItem.nprioridad || 'N/D'}</Typography>
      </Grid>
      <Grid item md={4} xs={6}>
        <Typography variant="body2">Sistema : {defaultItem.sistema || 'N/D'}</Typography>
      </Grid>
      <Grid item md={7} xs={6}>
        <Typography variant="body2">Título : {defaultItem.titulo || 'N/D'}</Typography>
      </Grid>
      <Grid item md={5} xs={6}>
        <Typography variant="body2">Solicitante : {defaultItem.solicitante || 'N/D'}</Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography variant="body2">Problemática : {defaultItem.problematica || 'N/D'}</Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography variant="body2">Correo : {defaultItem.correo || 'N/D'}</Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography variant="body2">Descripción de la solicitud : {defaultItem.desc_solicitud || 'N/D'}</Typography>
      </Grid>
      <Grid item xs={12}>
        {/* <Typography variant="h6">
          Propuesta
        </Typography><br /> */}
        <Divider />
      </Grid>
      <Grid item md={6} xs={7}>
        <Autocomplete
          multiple
          options={ctlg.proyectos}
          getOptionLabel={(option) => option.nproyecto}
          getOptionSelected={(option, value) => option.idproyecto == value.idproyecto}
          value={watch('proyecto')}
          onChange={cambioProyecto}
          size="small"
          fullWidth
          renderInput={(params) => (
            <TextField label="Proyectos" variant="outlined" {...params}
              error={errors.proyecto != undefined} helperText={errors.proyecto}
            />
          )}
        />
      </Grid>
    </Grid>

  );
}
